import { bin_icon_red, three_dots_menu, user_profile_1 } from "../../imagepath";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import ComponentLoader from "../../loadings/ComponentLoader";
import ConfirmDelete from "../../modals/ConfirmDelete";
import { useState } from "react";
import { useDeleteReview } from "../../../hooks/review/useDeleteReview";

function Review(props) {
  const { reviews, isLoading } = props;
  const [show, setShow] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);
  const [expandedReviews, setExpandedReviews] = useState({});
  const { mutate, isLoading: deleteLoading } = useDeleteReview(selectedReview);
  
  const handleDeleteClick = (review, e) => {
    e.stopPropagation();
    e.preventDefault();
    
    setSelectedReview(review);
    setShow(true);
  };


  const handleDelete = async () => {
    if (selectedReview) {
      await mutate(selectedReview, {
        onSuccess: () => {
          setShow(false);
        },
      });
    }
  };

  const toggleExpanded = (reviewId) => {
    setExpandedReviews(prev => ({
      ...prev,
      [reviewId]: !prev[reviewId]
    }));
  };

  const truncateText = (text, maxLength = 150) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  return (
    <div className="row mt-3 tab-list">
      {!isLoading ? (
        <>
          {reviews.length > 0 ? (
            <div className="row">
              {reviews.map((review) => {
                return (
                  <div
                    className="col-md-6 col-sm-6 col-lg-4 col-xl-4"
                    key={review.id}
                    style={{ zIndex: 1 }}
                  >
                    <div className="dash-widget review-card" style={{ position: 'relative', zIndex: 1 }}>
                      <div className="dash-content dash-count flex-grow-1">
                        <div className="row">
                          <div className="col-2 mt-1">
                            <img src={user_profile_1} alt="profile_picture" />
                          </div>
                          <div className="col-8 mt-2">
                            <p>
                              {review?.user?.first_name +
                                " " +
                                (review?.user?.last_name ?? "")}
                            </p>
                            <div>
                              {[...Array(5)].map((_, index) => (
                                <i
                                  key={index}
                                  className={`fa fa-star ${
                                    index < parseInt(review.rating) ? "active" : ""
                                  }`}
                                ></i>
                              ))}
                            </div>
                          </div>
                          <div className="col-2 d-flex justify-content-end">
                            <div className="dropdown" style={{ position: 'static' }}>
                              <Link
                                to="#"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                id={`customdropdown-${review.id}`}
                              >
                                <img src={three_dots_menu} alt="" />
                              </Link>
                              <div
                                className="dropdown-menu dropdown-menu-end"
                                aria-labelledby={`customdropdown-${review.id}`}
                                style={{ position: 'fixed', zIndex: 9999 }}
                              >
                                <Link
                                  className="dropdown-item d-flex"
                                  onClick={(e) => handleDeleteClick(review.id,e)}
                                >
                                  <img
                                    src={bin_icon_red}
                                    alt="delete"
                                    className="me-2 ms-1"
                                    width={16}
                                    height={16}
                                  />
                                  <span className="text-danger ps-1">
                                    Delete
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="review-description pt-3">
                          <p>
                            {expandedReviews[review.id] 
                              ? review.review_note 
                              : truncateText(review.review_note , 185)
                            }
                          </p>
                          {review.review_note  && review.review_note.length > 150 && (
                            <button
                              className="btn btn-link p-0 text-primary"
                              style={{ fontSize: '12px', textDecoration: 'none' }}
                              onClick={() => toggleExpanded(review.id)}
                            >
                              {expandedReviews[review.id] ? 'See less' : 'See more'}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="d-flex flex-column justify-content-center align-items-center py-5">
              <div className="mb-3">
                <i className="fas fa-star text-muted" style={{ fontSize: '48px' }}></i>
              </div>
              <h5 className="text-muted mb-2">No Reviews Found</h5>
            </div>
          )}
        </>
      ) : (
        <ComponentLoader />
      )}
      <ConfirmDelete
        show={show}
        setShow={setShow}
        title="Review"
        handleDelete={handleDelete}
        isLoading={deleteLoading}
      />
    </div>
  );
}

Review.propTypes = {
  reviews: PropTypes.array,
  isLoading: PropTypes.bool,
};

export default Review;
